import React from 'react';
import PropTypes from 'prop-types';

const HypertextLink = ({
  href,
  className = '',
  id = '',
  children,
  target = '',
  dataTestId = undefined,
}) => {
  return (
    <a
      href={href}
      className={`${className || 'inline-flex p-2.5 justify-center items-center text-center text-lg font-normal leading-normal underline'}`}
      id={id}
      target={target}
      data-testid={dataTestId}
    >
      {children}
    </a>
  );
};

HypertextLink.propTypes = {
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  target: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default HypertextLink;
